export default __webpack_public_path__ + "static/Group 148459-7a4f67952d6ae35cb353852182f44a0a.png";